import CheckboxComponent from '@components/inputs/checkbox/Checkbox.component';
import NumberTextFieldComponent from '@components/inputs/numberTextField/NumberTextField.component';
import SelectComponent from '@components/inputs/select/Select.component';
import { Stack, Typography } from '@mui/material';
import { AuditOperationScheduleDto, CreateAuditOperation } from '@store/audits/audits-operation/audits-operation.model';
import { NumeralDayOfMonth, WeekDay } from '@store/common/schedule.model';
import { getTypeOf } from '@utils/getTypeOf';
import { useEffect, useState } from 'react';

interface AuditContainerProps {
  auditOperation?: CreateAuditOperation;
  updateAuditOperation: <T extends keyof CreateAuditOperation>(
    field: T,
    value: CreateAuditOperation[T]
  ) => void;
}

const MonthlyCollect = (props: AuditContainerProps) => {

  const {
    auditOperation,
    updateAuditOperation
  } = props;

  const [frequency, setFrequency] = useState<AuditOperationScheduleDto>();

  useEffect(() => {
    if (auditOperation?.frequency?.isDayOfMonth) {
      updateAuditOperation('frequency', {
        numeralDayOfMonth: undefined,
        weekDayForMonth: undefined,
      });
    } else {
      updateAuditOperation('frequency', {
        dayOfMonth: undefined,
        monthlyFrequencyNumber: undefined,
      });
    }
  }, [auditOperation?.frequency?.isDayOfMonth, updateAuditOperation]);

  useEffect(() => {
    if (auditOperation) {
      if (auditOperation.schedule) {
        const frequencyitem: AuditOperationScheduleDto = getTypeOf<AuditOperationScheduleDto>(auditOperation.schedule!);
        updateAuditOperation('frequency', {
          dayOfMonth: frequencyitem.dayOfMonth,
          monthlyFrequencyNumber: frequencyitem.monthlyFrequencyNumber,
          isDayOfMonth: frequencyitem.isDayOfMonth,
          numeralDayOfMonth: frequencyitem.numeralDayOfMonth,
          weekDayForMonth: frequencyitem.weekDayForMonth,
        });
        setFrequency(frequencyitem);
      }
    }
  }, [auditOperation?.schedule, auditOperation, updateAuditOperation]);

  return (
      <Stack spacing={2} justifyContent={'flex-start'} pl={'140px'}>
        <Stack spacing={2} alignItems={'flex-start'}>
          <Stack alignItems={'flex-start'}>
            <Stack direction="row" alignItems="center">
              <CheckboxComponent
                  handleChange={() =>  updateAuditOperation('frequency', { isDayOfMonth: true })}
                  labelPlacement='end'
                  label='Le'
                  value={auditOperation?.frequency?.isDayOfMonth ?? false}
              />
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
              >
                <NumberTextFieldComponent
                  inputWidth={80}
                  pattern={new RegExp(/^(\d*|\d+)$/)}
                  handleChange={(value) => {
                    updateAuditOperation('frequency', { dayOfMonth: value });
                    setFrequency({ ...frequency, dayOfMonth: value });
                  }}
                  value={auditOperation?.frequency?.dayOfMonth}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        <Stack>
          <Stack direction="row" alignItems="center">
            <CheckboxComponent
                handleChange={() =>  updateAuditOperation('frequency', { isDayOfMonth: false })}
                labelPlacement='end'
                label='Le'
                value={!auditOperation?.frequency?.isDayOfMonth ?? false}
            />
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
            >
              <SelectComponent
                  inputWidth={140}
                  handleChange={(numeralDayOfMonth) => updateAuditOperation('frequency', { numeralDayOfMonth: numeralDayOfMonth })}
                  value={auditOperation?.frequency?.numeralDayOfMonth}
                  items={NumeralDayOfMonth.selectItems()}
              />
              <SelectComponent
                  inputWidth={130}
                  handleChange={(weekDayForMonth) => updateAuditOperation('frequency', { weekDayForMonth: weekDayForMonth })}
                  value={auditOperation?.frequency?.weekDayForMonth}
                  items={WeekDay.selectItems}
              />
            </Stack>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={2} alignItems={'flex-start'}>
          <Stack alignItems={'flex-start'}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography
                fontSize={14}
                fontWeight="400"
              >
                Tous les
              </Typography>
              <NumberTextFieldComponent
                value={frequency?.monthlyFrequencyNumber || 0}
                inputWidth={80}
                pattern={new RegExp(/^(\d*|\d+)$/)}
                handleChange={(value) => {
                  updateAuditOperation('frequency', { monthlyFrequencyNumber: value });
                  setFrequency({ ...frequency, monthlyFrequencyNumber: value });
                }}
              />
              <Typography
                fontSize={14}
                fontWeight="400"
              >
                mois
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
  );
};

export default MonthlyCollect;